import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {GoogleMapModel} from "../../../models/googleMap.model";

@Injectable({
  providedIn: 'root'
})
export class GoogleMapService {
  baseUrl = `${environment.URL_Back}`;
  private loadingPromise?: Promise<void>;

  constructor(private http: HttpClient) {
  }

  public load() {
    console.log("The Google Map service performs the loading function.");
    const scriptId = "google-maps-js";
    if (window.google?.maps) return Promise.resolve();

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    const existingTagScript = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (existingTagScript) {
      this.loadingPromise = new Promise<void>((resolve, reject) => {
        existingTagScript.addEventListener('load', () => resolve());
        existingTagScript.addEventListener('error', () => reject());
      });
      return this.loadingPromise;
    }

    this.loadingPromise = new Promise<void>((resolve, reject) => {
      this.http.get<GoogleMapModel>(`${this.baseUrl}GoogleMap`).subscribe({
        next: (googleMap: GoogleMapModel) => {
          (window as any)['__googleMapsReady'] = () => resolve();
          const script = document.createElement('script');
          script.text = googleMap.jsCode + '\n__googleMapsReady();';
          script.id = scriptId;
          document.head.appendChild(script);
          if (window.google?.maps) resolve();
        },
        error: (err) => reject(err)
      });
    });
    return this.loadingPromise;
  }
}
